import React from 'react';
import DetailPage from './DetailPage';
import DetailPageHeroVideo from './DetailPageHeroVideo';

const DetailPageMetaAvatars = () => {
  return (
    <DetailPage 
      title="Meta Reality Labs Avatar Editor"
      heroSrc={'/images/meta-avatars/header.png'}
      content="During my time at Meta Reality Labs, I contributed to the redesign of the avatar editor for Meta Quest—the experience where people create and customize how they show up in VR. The work was about more than sliders and presets: we were exploring how identity and embodiment translate into virtual worlds, and what it means to feel like yourself when your body is digital. The goal was to make the editor feel expressive, inclusive, and true to the ways people want to be seen."
      year="2020"
      duration="3 months"
      role="Designer"
    >
      <DetailPageHeroVideo
        src="/videos/meta-avatars/SavedLooks.mp4"
        poster="/path/to/thumbnail.jpg"
        lazy={true}
        autoPlay={true}
        muted={true}
        loop={true}
      />
    </DetailPage>
  );
};

export default DetailPageMetaAvatars; 